const BREAKPOINT = {
  DESKTOP: window.matchMedia('(min-width: 750px)'),
};

function onBreakpoint(media, cb) {
  if (!media) return;
  const handleChange = () => cb(media.matches);
  const remove = () => {
    media.removeEventListener('change', handleChange);
    cb = null;
  };

  handleChange();
  media.addEventListener('change', handleChange);
  return remove;
}

const focusableElementsCache = new WeakMap();

function getFocusableElements(container) {
  if (focusableElementsCache.has(container)) {
    return focusableElementsCache.get(container);
  }

  const elements = Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );

  focusableElementsCache.set(container, elements);
  return elements;
}

let summaries = document.querySelectorAll('summary.header__menu-item');
summaries.forEach((summary) => {
  let details = summary.closest('details');
  summary.addEventListener('mouseenter', (event) => {
    details.setAttribute('open', 'open');
  });
  details.addEventListener('mouseleave', (event) => {
    event.target.classList.add('summary-closing');
    setTimeout(function () {
      event.target.removeAttribute('open');
    }, 100);
    event.target.setAttribute('open', 'open');
  });
});

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling?.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    if (summary.classList.contains('js-menu-item_level-1__title')) {
      document.querySelectorAll('.js-menu-item_level-1__title').forEach((menu) => {
        if (summary != menu) {
          menu.parentNode.removeAttribute('open');
        }
      });
    }
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  let footerDetails = summary.closest('.footer-block details');
  onBreakpoint(BREAKPOINT.DESKTOP, (open) => {
    if (!footerDetails) return;
    open ? footerDetails.setAttribute('open', '') : footerDetails.removeAttribute('open');
    open ? footerDetails.setAttribute('disabled', '') : footerDetails.removeAttribute('disabled');
    open ? summary.setAttribute('tabindex', '-1') : summary.removeAttribute('tabindex');
  });
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  if (elementToFocus) {
    requestAnimationFrame(() => {
      elementToFocus.focus();

      if (
        elementToFocus.tagName === 'INPUT' &&
        ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
        elementToFocus.value
      ) {
        elementToFocus.setSelectionRange(0, elementToFocus.value.length);
      }
    });
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  // if search is open, don't focus on other elements
  if (document.querySelector('.search-modal__input')?.closest('details')?.hasAttribute('open')) {
    return;
  }
  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus?.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus?.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');
    this.navigationContainer = document.querySelector('.menu-drawer__navigation-container');
    this.isMobile = window.innerWidth < 750;
    this.isTablet = window.innerWidth < 990;
    this.viewportHeightTimeout = null;

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.addEventListener('click', this.onClick.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('button:not(.localization-selector)').forEach((button) =>
      button.addEventListener('click', this.onCloseButtonClick.bind(this))
    );
  }

  setViewportHeight = () => {
    requestAnimationFrame(() => {
      document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
    });
  };

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }
  onClick(event) {
    const summary = event.target.closest('summary');
    if (summary) {
      this.onSummaryClick(event);
    }
  }
  onSummaryClick(event) {
    const summaryElement = event.target.closest('summary');
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }
    // todo: consider remove this condition. not clear when we migth need it
    // when filetr sort by updated, the details element renders again
    // and does not indentified asmain anymore, which broke the opening logic
    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (this.isTablet) {
        debounce(this.setViewportHeight, 100);
      }
    } else {
      // still open in case of js-filter drawer
      if (detailsElement.classList.contains('js-sort-details')) {
        this.openMenuDrawer(summaryElement);
      }
      requestAnimationFrame(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', 'true');
        parentMenuElement && parentMenuElement.classList.add('submenu-open');

        requestAnimationFrame(() => {
          !reducedMotion || reducedMotion.matches
            ? addTrapFocus()
            : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
        });
      });
    }
  }

  openMenuDrawer(summaryElement) {
    requestAnimationFrame(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
      summaryElement.setAttribute('aria-expanded', 'true');
      document.body.classList.add(this.isMobile ? 'overflow-hidden-mobile' : 'overflow-hidden');

      requestAnimationFrame(() => {
        trapFocus(this.mainDetailsToggle, summaryElement);
      });
    });
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    document.body.classList.remove(this.isMobile ? 'overflow-hidden-mobile' : 'overflow-hidden');
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
    this.navigationContainer && (this.navigationContainer.scrollTop = 0);
    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    detailsElement && this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    document.body.classList.remove('overflow-hidden', 'overflow-hidden-mobile');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
    this.header = document.querySelector('.section-header');
    this.borderOffset = this.closest('.header-wrapper')?.classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    this.cachedHeaderBottom = null;
    this.debouncedOnResize = debounce(this.onResize, 150);
  }

  openMenuDrawer(summaryElement) {
    requestAnimationFrame(() => {
      this.cachedHeaderBottom = this.header.getBoundingClientRect().bottom;

      requestAnimationFrame(() => {
        document.documentElement.style.setProperty(
          '--header-bottom-position',
          `${parseInt(this.cachedHeaderBottom - this.borderOffset)}px`
        );
      });

      this.header.classList.add('menu-open');
      this.mainDetailsToggle.classList.add('menu-opening');
      summaryElement.setAttribute('aria-expanded', 'true');
      document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);

      requestAnimationFrame(() => {
        trapFocus(this.mainDetailsToggle, summaryElement);
      });
    });

    window.addEventListener('resize', this.debouncedOnResize);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.debouncedOnResize);
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  onResize = () => {
    if (this.header) {
      requestAnimationFrame(() => {
        const newBottom = this.header.getBoundingClientRect().bottom;
        if (newBottom !== this.cachedHeaderBottom) {
          this.cachedHeaderBottom = newBottom;
          document.documentElement.style.setProperty(
            '--header-bottom-position',
            `${parseInt(newBottom - this.borderOffset)}px`
          );
        }
      });
    }
    this.setViewportHeight();
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));

    // Auto-load when scrolled into view
    this.setupIntersectionObserver();
  }

  setupIntersectionObserver() {
    const options = {
      root: null,
      rootMargin: '50px',
      threshold: 0.1,
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting && !this.getAttribute('loaded')) {
          setTimeout(() => {
            if (!this.getAttribute('loaded')) {
              this.loadContent(false);
              observer.unobserve(this);
            }
          }, 100);
        }
      });
    }, options);

    observer.observe(this);

    this._observer = observer;
  }

  disconnectedCallback() {
    if (this._observer) {
      this._observer.disconnect();
    }
  }

  loadContent(focus = true) {
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = content.querySelector('video, model-viewer, iframe');
      if (deferredElement) {
        this.appendChild(deferredElement);
        if (focus) deferredElement.focus();
        if (deferredElement.nodeName == 'VIDEO') {
          deferredElement.play().catch((error) => {
            console.warn('Video autoplay failed:', error);
          });
        }
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
    this.selectedVariantState = (this.querySelector('input:checked')) ? !this.querySelector('input:checked').classList.contains('disabled') : true;
  }

  onVariantChange() {
    const previousVariantAvailability = (this.currentVariant != undefined) ? this.currentVariant.available : this.selectedVariantState;
    this.toggleAddButton(true, '', false);
    this.updateOptions();
    this.updateMasterId();
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();
    
    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.updateShareUrl();
      if (this.currentVariant.available == true && previousVariantAvailability == true) {
        this.toggleAddButton(false, '', true);   
      }
      this.renderProductInfo();
    }
    
    this.dispatchEvent(
      new CustomEvent('variant:changed', {
        detail: {
          currentVariant: this.currentVariant,
        },
        bubbles: true,
      })
    );
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach((mediaGallery) =>
      mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true)
    );

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    const newUrl = new URL(this.dataset.url, window.location.origin);
    newUrl.searchParams.set('variant', this.currentVariant.id);

    // Preserve existing URL parameters (like recommended=true, code=EARLY)
    const currentUrl = new URL(window.location);
    const currentParams = new URLSearchParams(currentUrl.searchParams);
    currentParams.delete('variant');
    currentParams.forEach((value, key) => {
      newUrl.searchParams.set(key, value);
    });
    window.history.replaceState({}, '', newUrl.toString());
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(':checked').value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.innerText = input.getAttribute('value');
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    this.removeAttribute('has-error');

    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
        this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html');

        const fragment = document.createDocumentFragment();
        fragment.append(...html.body.children);

        const addButtonUpdated = fragment.getElementById(`ProductSubmitButton-${sectionId}`);
        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true,
          window.variantStrings.soldOut
        );

        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = fragment.getElementById(
          `price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuSource = fragment.getElementById(
          `Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = fragment.getElementById(
          `Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

        // Updating Availability and delivery message
        const availabilityDestination = document.querySelector('.js-product-availability');
        const availabilitySource = fragment.querySelector('.js-product-availability');

        if (availabilitySource && availabilityDestination) {
          availabilityDestination.innerHTML = availabilitySource.innerHTML;
        }
        // Updating product price section
        const productPriceDestination = document.querySelector('.js-product-price');
        const productPriceSource = fragment.querySelector('.js-product-price');
        
        if (productPriceSource && productPriceDestination) {
          productPriceDestination.innerHTML = productPriceSource.innerHTML;
        }
        const productDiscountDestination = document.querySelector('.js-product-discounted-price');
        const productDiscountSource = fragment.querySelector('.js-product-discounted-price');
        if (productDiscountSource && productDiscountDestination) {
          productDiscountDestination.innerHTML = productDiscountSource.innerHTML;
        }

        const volumePricingSource = fragment.getElementById(
          `Volume-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        const pricePerItemDestination = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
        const pricePerItemSource = fragment.getElementById(
          `Price-Per-Item-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        const volumePricingDestination = document.getElementById(`Volume-${this.dataset.section}`);
        const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);
        const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);

        if (volumeNote) volumeNote.classList.remove('hidden');
        if (volumePricingDestination) volumePricingDestination.classList.remove('hidden');
        if (qtyRules) qtyRules.classList.remove('hidden');

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('hidden', skuSource.classList.contains('hidden'));
        }

        if (volumePricingSource && volumePricingDestination) {
          volumePricingDestination.innerHTML = volumePricingSource.innerHTML;
        }

        if (pricePerItemSource && pricePerItemDestination) {
          pricePerItemDestination.innerHTML = pricePerItemSource.innerHTML;
          pricePerItemDestination.classList.toggle('hidden', pricePerItemSource.classList.contains('hidden'));
        }

        const price = document.getElementById(`price-${this.dataset.section}`);
        
        if (price) price.classList.remove('hidden');

        if (inventoryDestination) inventoryDestination.classList.toggle('hidden', inventorySource.innerText === '');

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    // Update shipping info visibility
    const shippingInfo = document.getElementById('shippingInfo');
    if (shippingInfo) {
      addButton.hasAttribute('disabled')
        ? shippingInfo.classList.add('hidden')
        : shippingInfo.classList.remove('hidden');
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);
    const pricePerItem = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
    const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);
    const volumeTable = document.getElementById(`Volume-${this.dataset.section}`);
    const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('hidden');
    if (inventory) inventory.classList.add('hidden');
    if (sku) sku.classList.add('hidden');
    if (pricePerItem) pricePerItem.classList.add('hidden');
    if (volumeNote) volumeNote.classList.add('hidden');
    if (volumeTable) volumeTable.classList.add('hidden');
    if (qtyRules) qtyRules.classList.add('hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled');
      } else {
        input.classList.add('disabled');
      }
    });
  }

  updateOptions() {
    this.setAttribute('selected', '');
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class DropdownSelects extends HTMLElement {
  constructor() {
    super();
    this.variantRadiosParents = document.querySelectorAll('variant-radios');
    this.select = this.querySelector('.dropdown-select');
    this.selectedText = this.querySelector('.dropdown-selected .text');
    this.options = this.querySelectorAll('.option');
    this.bodyLayer = document.querySelector('.body-layer');
    this.closeSelector = this.querySelector('.selector__close');

    this.addEventListener('click', this.onDropdownClick);
    this.select.addEventListener('click', this.onSelectClick.bind(this));
    document.addEventListener('click', this.onOutsideClick.bind(this));

    if (this.closeSelector) {
      this.closeSelector.addEventListener('click', this.closeSelectorEventListener.bind(this));
    }
  }

  closeSelectorEventListener() {
    this.removeAttribute('open');

    if (window.innerWidth < 750) {
      this.closeMobileSelector();
    }
  }

  onOutsideClick(e) {
    if (!this.contains(e.target)) {
      this.removeAttribute('open');
    }

    if (window.innerWidth < 750 && this.bodyLayer && e.target === this.bodyLayer) {
      this.closeMobileSelector();
    }
  }

  onDropdownClick(e) {
    if (!e.target.classList.contains('option') && !this.select?.classList.contains('cart-items__options')) {
      this.toggleAttribute('open');
    }

    if (window.innerWidth < 750) {
      document.body.appendChild(this.select);
      this.select.classList.add('active');
      this.bodyLayer.classList.remove('hidden');
    }
  }

  onSelectClick(e) {
    if (this.tagName.toLowerCase() === 'dropdown-selects-options') {
      return;
    }

    // make sure we addressing click on the option element
    const targetOption = e.target.closest('.option');
    if (!targetOption) return;

    if (targetOption.classList.contains('option--disabled')) {
      this.removeAttribute('open');
      return;
    }

    if (targetOption.dataset.optionValue) {
      // PDP sticky buy bar case -- not proceed with soldout variants
      if (targetOption.dataset.soldOut !== undefined) {
        return;
      }
      this.setAttribute('selected', '');
      this.selectedText.textContent = targetOption.dataset.optionValue;
      this.selectedText.classList.remove('subtitle-small');
      if (targetOption.querySelector('.text')?.classList.contains('sold-out')) {
        this.selectedText.classList.add('sold-out');
      } else {
        this.selectedText.classList.remove('sold-out');
      }
      this.variantRadiosParents.forEach((element) => {
        element.querySelectorAll('input').forEach((input) => {
          if (targetOption.dataset.optionValue === input.value) {
            input.click();
          }
        });
      });

      this.options.forEach((option) => option.classList.remove('selected'));
      targetOption.classList.add('selected');
      this.removeAttribute('open');
    }

    if (window.innerWidth < 750) {
      this.closeMobileSelector();
    }

    if (
      window.innerWidth < 750 &&
      (targetOption.classList.contains('selector__title') || targetOption.closest('.selector__close') != undefined)
    ) {
      this.removeAttribute('open');
    }
  }

  closeMobileSelector() {
    window.__dropdownIsClosing = true;

    if (this.select.parentElement === document.body) {
      document.body.removeChild(this.select);
    }
    this.select.classList.remove('active');
    this.appendChild(this.select);
    this.bodyLayer.classList.add('hidden');

    setTimeout(() => {
      window.__dropdownIsClosing = false;
    }, 100);
  }
}

customElements.define('dropdown-selects', DropdownSelects);

class DropdownSelectsItemQuantity extends DropdownSelects {
  constructor() {
    super();
    this.select?.addEventListener('click', this.onQuantityUpdate.bind(this));
    this.quantityInputWrapper = this.querySelector('.cart-quantity-wrapper');
    this.selectedOption = this.querySelector('.dropdown-selected');
    this.options = this.querySelectorAll('.option');
    this.bodyLayer = document.querySelector('.body-layer');
    this.addEventListener('click', this.onDropdownClick);
  }

  onDropdownClick(e) {
    if (!e.target.classList.contains('option')) {
      this.toggleAttribute('open');
    }

    if (window.innerWidth < 750 && this.quantityInputWrapper?.classList.contains('visibility-hidden')) {
      document.body.appendChild(this.select);
      this.select.classList.add('active');
      this.bodyLayer.classList.remove('hidden');
    }
  }

  onQuantityUpdate(e) {
    const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');

    if (e.target.dataset.manualUpdate != 'true') {
      e.target.dataset.index &&
        cartItems?.updateQuantity(e.target.dataset.index, parseInt(e.target.dataset.optionValue));
      this.closeMobileSelector();
    } else {
      this.selectedOption?.classList.add('visibility-hidden');
      this.quantityInputWrapper?.classList.remove('visibility-hidden');
    }
  }
}

customElements.define('dropdown-selects-item-quantity', DropdownSelectsItemQuantity);

class DropdownSelectsOptions extends DropdownSelects {
  constructor() {
    super();
    this.select?.addEventListener('click', this.onOptionUpdate.bind(this));
    this.cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
  }

  onDropdownClick(e) {
    if (!e.target.classList.contains('option') && !this.select?.classList.contains('cart-items__options')) {
      this.toggleAttribute('open');
    }

    if (window.innerWidth < 750) {
      document.body.appendChild(this.select);
      this.select.classList.add('active');
      this.bodyLayer.classList.remove('hidden');
    }
  }

  onOptionUpdate(e) {
    e.stopPropagation();

    const targetOption = e.target.closest('.option');
    if (!targetOption) return;

    if (targetOption.classList.contains('option--disabled')) {
      e.preventDefault();
      return;
    }

    let currentVariantId = targetOption.dataset.currentVariantId;
    let updatedVariantId = targetOption.dataset.updatedVariantId;
    let quantity = targetOption.dataset.quantity;
    let line = parseInt(targetOption.dataset.line);

    if (currentVariantId == updatedVariantId) {
      e.preventDefault();
      this.removeAttribute('open');
      if (window.innerWidth < 750) {
        this.closeMobileSelector();
      }
      return;
    }

    /* Shopify doesn't allow to update variant of line item, therefore:
      1. Remove the current line item variant
      2. Add a the selected variant to cart
    */

    this.replaceVariant(line, updatedVariantId, quantity);
  }

  replaceVariant(currentLineIndex, updatedVariantId, quantity) {
    this.removeAttribute('open');

    if (window.innerWidth < 750) {
      this.closeMobileSelector();
    }

    this.cartItems?.enableLoading(currentLineIndex);

    // Set flag to prevent extra services sync during variant replacement
    const extraServices = document.querySelector('cart-drawer-extra-services');
    if (extraServices) {
      extraServices.isVariantReplacementInProgress = true;
    }

    let selectedOption = this.select.querySelector(`[data-line="${currentLineIndex}"]`);
    const currentBody = JSON.stringify({
      line: currentLineIndex,
      quantity: 0,
      sections: this.cartItems?.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    const updatedBody = JSON.stringify({
      id: updatedVariantId,
      quantity: quantity,
      sections: this.cartItems?.getSectionsToRender().map((section) => section.section),
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body: currentBody } })
      .then(async (response) => {
        if (!response.ok) {
          const errorText = await response.text();
          console.error(`Cart change API error (${response.status}):`, errorText);
          throw new Error(`Failed to remove variant: ${response.status} ${response.statusText}`);
        }
        const responseText = await response.text();
        const responseJson = JSON.parse(responseText);
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'cart-items',
          cartData: responseJson,
        });

        // Add a delay to ensure the variant is removed from the cart
        await new Promise((resolve) => setTimeout(resolve, 200));

        return responseText;
      })
      .then(async (data) => {
        return fetch(`${routes.cart_add_url}`, { ...fetchConfig(), ...{ body: updatedBody } }).then(
          async (response) => {
            if (!response.ok) {
              const errorText = await response.text();
              console.error(`Cart add API error (${response.status}):`, errorText);
              throw new Error(`Failed to add variant: ${response.status} ${response.statusText}`);
            }
            const responseText = await response.text();
            const responseJson = JSON.parse(responseText);

            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'cart-items-add',
              cartData: responseJson,
            });

            return responseText;
          }
        );
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        this.cartItems?.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id)?.querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML = this.cartItems?.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });

        if (window.updateWishlistStateImmediately) {
          window.updateWishlistStateImmediately();
        }

        // Re-attach event listeners to cart drawer after variant update
        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer) {
          cartDrawer.reattachEventListeners();
        }
      })
      .catch((error) => {
        console.error('Error replacing variant:', error);
      })
      .finally(() => {
        // Clear flag to allow extra services sync again
        const extraServices = document.querySelector('cart-drawer-extra-services');
        if (extraServices) {
          extraServices.isVariantReplacementInProgress = false;
        }

        this.closeMobileSelector();
        this.cartItems?.disableLoading(currentLineIndex);
      });
  }
}

customElements.define('dropdown-selects-options', DropdownSelectsOptions);

class LazyLoadProducts extends HTMLElement {
  constructor() {
    super();
    this.collectionContext = this.getAttribute('data-collection');
    this.handles = this.getAttribute('data-handles') || '';
    this.limit = this.getAttribute('data-limit') || 50;
    this.container = this.querySelector('.js-products-container');
    this.listItemCustomClass = this.getAttribute('data-list-item-class') || '';
    this.observer = null;
  }
  connectedCallback() {
    if (this.handles && this.container) {
      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this._loadProducts();
            this.observer.disconnect();
          }
        });
      });

      this.observer.observe(this);
    }
  }

  async _loadProducts() {
    try {
      const url = `/collections/${this.collectionContext}?view=list-products&type=${this.handles}&limit=${this.limit}`;
      const response = await fetch(url);
      const htmlText = await response.text();

      const parser = new DOMParser();
      const parsedHTML = parser.parseFromString(htmlText, 'text/html');
      const parsedElements = parsedHTML.querySelectorAll('.js-fetched-item');
      const fragment = document.createDocumentFragment();
      const customClassArray = this.listItemCustomClass.split(' ').filter((cls) => cls.trim() !== '');
      parsedElements.forEach((element) => {
        element.classList.add(...customClassArray);
        fragment.appendChild(element);
      });

      this.container.innerHTML = '';
      this.container.appendChild(fragment);
    } catch (error) {
      console.error('Fetch error:', error);
    }
  }
  disconnectedCallback() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }
}
customElements.define('lazy-load-products', LazyLoadProducts);

class PopupRedirect extends ModalDialog {
  constructor() {
    super();
    this.currentMarketHandle = redirectData.current_market.handle;
    this.id = this.getAttribute('id');

    this.view1 = this.querySelector('#view-1');
    this.view2 = this.querySelector('#view-2');
    this.modalContent = this.querySelector('.country-redirect-popup-modal__content');
    this.switchToOtherViewButton = this.querySelector('#switch-to-other-view');
    this.backToFirstViewButton = this.querySelector('#back-to-first-view');
    this.continueCurrentMarketButton = this.querySelector('#continue-current-market');

    this.initViewSwitching();
    this.initContinueMarketButton();

    // Check if the popup should be displayed
    if (sessionStorage.getItem(this.id) === 'true') {
      return;
    } else if (sessionStorage.getItem(this.id) === null) {
      this.fetchBrowserContextSuggestions();
    }
  }

  initViewSwitching() {
    // Switch to the second view
    this.switchToOtherViewButton.addEventListener('click', () => {
      this.view1.style.display = 'none';
      this.view2.style.display = 'block';
      this.modalContent.classList.add('view-2');
      this.modalContent.classList.remove('view-1');
    });

    // Go back to the first view
    this.backToFirstViewButton.addEventListener('click', () => {
      this.view2.style.display = 'none';
      this.view1.style.display = 'block';
      this.modalContent.classList.add('view-1');
      this.modalContent.classList.remove('view-2');
    });
  }

  initContinueMarketButton() {
    this.continueCurrentMarketButton.addEventListener('click', () => {
      sessionStorage.setItem(this.id, 'true');

      this.removeAttribute('open');
    });
  }

  // Method to fetch the browsing context suggestions
  fetchBrowserContextSuggestions() {
    const url = `${location.origin}/browsing_context_suggestions.json`;
    fetch(url)
      .then((response) => response.json())
      .then((data) => {
        this.contextData = data.detected_values;
        this.userCountryHandle = this.contextData.country.handle.toLowerCase();
        this.userCountryName = this.contextData.country_name;
        this.isInternationalMarket =
          this.currentMarketHandle === 'international' &&
          redirectData.markets.international.supported_countries.includes(this.userCountryHandle);

        if (this.currentMarketHandle === this.userCountryHandle || this.isInternationalMarket) return;

        // Show view-1
        this.view2.style.display = 'none';
        this.view1.style.display = 'block';

        this.setAttribute('open', '');
      })
      .catch((error) => {
        console.error(error);
      });
  }
}

customElements.define('popup-redirect', PopupRedirect);
